<template>
  <div class="app-container">
    <div class="title-container">
      <div>兑换审核列表</div>
      <p>审核会员兑换申请，待审核订单可通过或驳回。</p>
    </div>

    <div class="filter-container">
      <el-input
        v-model="listQuery.userId"
        placeholder="会员ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.orderNo"
        placeholder="订单编号"
        style="width: 200px"
        class="filter-item"
        clearable
      />

      <el-select
        v-model="listQuery.auditType"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in AUDIT_STATUS_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <DataPicker
        @valueFunc="getPickerValueFunc"
        startPlaceholder="支付开始时间"
        endPlaceholder="支付截止时间"
      />

      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <div style="display:flex; align-items: center; margin-bottom: 10px;">
      <div style="margin-bottom: 5px">订单数量:{{ total }}</div>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="userId" label="会员ID" width="190"></el-table-column>
      <el-table-column align="center" prop="orderNo" label="订单编号" width="190"></el-table-column>
      <el-table-column label="联系姓名" align="center" prop="name" width="110"></el-table-column>
      <el-table-column label="联系电话" align="center" prop="phone" width="120"></el-table-column>

      <el-table-column class-name="status-col" label="状态" align="center" width="120">
        <template slot-scope="scope">
          <el-tag
            :color="getValue(ORDER_STATUS_CSS, scope.row && scope.row.audit)"
            style="color: #FFFFFF"
            >{{ getValue(AUDIT_STATUS, scope.row && scope.row.audit) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="商品名称" prop="title" align="center">
        <template slot-scope="scope">
          {{
            (scope.row && scope.row.items && scope.row.items[0] && scope.row.items[0].title) || "-"
          }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="支付数字积分"
        prop="buyDeductionValue"
        align="center"
        width="120"
      />
      <el-table-column
        class-name="status-col"
        label="支付人民币"
        prop="payAmount"
        align="center"
        width="120"
      >
        <template slot-scope="scope"> ¥{{ (scope.row && scope.row.payAmount) || 0 }} </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="支付方式" align="center" width="100">
        <template slot-scope="scope">
          <el-tag>{{ getValue(ORDER_PAY_PLATFORM, scope.row && scope.row.payPlatform) }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="payTime" label="支付时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row && scope.row.payTime" />
          <span>{{ formatApiDate(scope.row && scope.row.payTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="220"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleAuditPass(scope.row)"
            class="comm_but_warp"
            v-if="scope.row && scope.row.audit === 0"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    审核弹窗-->
    <el-dialog
      title="审核"
      :visible.sync="shipmentsVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <div class="card_content">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="订单编号">{{ orderInfo.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="会员ID">{{ orderInfo.userId }}</el-descriptions-item>
          <el-descriptions-item label="商品名称">
            {{
              (orderInfo && orderInfo.items && orderInfo.items[0] && orderInfo.items[0].title) ||
                "-"
            }}
          </el-descriptions-item>
          <el-descriptions-item label="支付金额">{{
            (orderInfo.buyDeductionValue || 0) + "积分 + ¥" + (orderInfo.payAmount || 0)
          }}</el-descriptions-item>
          <el-descriptions-item label="当前状态">
            {{ getValue(AUDIT_STATUS, orderInfo && orderInfo.audit) }}
          </el-descriptions-item>
        </el-descriptions>
        <el-form>
          <el-form-item label="审核备注">
            <el-input
              v-model="auditRemark"
              type="textarea"
              placeholder="请输入通过说明或驳回原因"
              :rows="3"
            />
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="handleAuditResult(1)" :loading="shipmentsBtnLoading"
          >审核通过</el-button
        >
        <el-button type="danger" @click="handleAuditResult(2)" :loading="shipmentsBtnLoading"
          >审核驳回</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderList, auditOrder } from "@/api/order";
import { formatApiDate } from "@/utils/utils";
import { getValue, AUDIT_STATUS, AUDIT_STATUS_TYPE, ORDER_PAY_PLATFORM } from "@/utils/enumUtile";
import { ORDER_STATUS_CSS } from "@/utils/enumUtileCss";
import DataPicker from "@/views/components/dataPicker.vue";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    ORDER_STATUS_CSS() {
      return ORDER_STATUS_CSS;
    },
    AUDIT_STATUS() {
      return AUDIT_STATUS;
    },
    AUDIT_STATUS_TYPE() {
      return AUDIT_STATUS_TYPE;
    },
    ORDER_PAY_PLATFORM() {
      return ORDER_PAY_PLATFORM;
    }
  },
  components: { DataPicker },
  filters: {},
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        orderNo: null,
        userId: null,
        auditType: -1
      },
      shipmentsVisible: false,
      orderInfo: {},
      shipmentsBtnLoading: false,
      auditRemark: ""
    };
  },
  created() {
    const savedState = sessionStorage.getItem("pageState");
    // 只有当 savedState 存在且是有效的 JSON 字符串时才恢复状态
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      // 确保解析后的数据是对象类型
      if (parsedState && typeof parsedState === "object") {
        this.listQuery = { ...this.listQuery, ...parsedState };
      }
    }
    sessionStorage.removeItem("pageState");
    this.getList();
  },
  watch: {},
  methods: {
    getValue,

    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getOrderList(params)
        .then(response => {
          // 处理商品名称
          this.list = response.data.entitys.map(item => {
            if (!Array.isArray(item.items)) {
              console.log("商品名称为空", item);
              item.items = [];
            }
            return item;
          });
          console.log("查询列表", response.data, this.list);
          this.total = response.data.totalCount || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    handleAuditPass(item) {
      this.orderInfo = item;
      this.auditRemark = "";
      this.shipmentsVisible = true;
    },

    handleAuditResult(type) {
      this.shipmentsBtnLoading = true;
      const params = {
        id: this.orderInfo.id,
        status: type,
        auditRemark: this.auditRemark
      };
      auditOrder(params)
        .then(resp => {
          if (resp && resp.bizcode === 100) {
            this.orderInfo = {};
            this.auditRemark = "";
            this.shipmentsVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: type === 1 ? "审核通过" : "审核驳回",
              type: "success",
              duration: 2000
            });
          }
        })
        .finally(() => {
          this.shipmentsBtnLoading = false;
        });
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(value) {
      this.listQuery.payStartTime = value[0];
      this.listQuery.payEndTime = value[1];
    }
  }
};
</script>
<style scoped lang="scss">
.title-container {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;

  p {
    font-size: 14px;
    color: #909399;
    margin-top: 5px;
    font-weight: normal;
  }
}

.comm_but_warp {
  margin-bottom: 10px;
}

.filter-container {
  display: flex;
  /* 使用 flex 布局 */
  flex-wrap: wrap;
  /* 允许内容换行 */
  align-items: center;
  /* 垂直居中对齐 */
  gap: 10px;
  /* 元素之间的间距（现代浏览器支持） */
  margin-bottom: 20px;
  flex-direction: row;

  // 针对 filter-item 的统一样式
  .filter-item {
    margin-bottom: 0 !important;
    /* 清除默认的底部边距，由 gap 或容器控制 */
    flex-shrink: 0;
    /* 禁止压缩内容长度 */
  }
}

.comm_but_warp {
  margin-bottom: 5px;
}

.card_content {
  display: flex;
  flex-direction: column;
}
</style>
